import React, { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client/react";
import { SIGNIN } from "../../graphql/auth";
import { authClient } from "../../graphql/client";
import { useAuth } from "../../contexts/AuthContext";
import { Input } from "../atoms/Input";

interface SigninBackofficeData {
  signinBackoffice: {
    id: string;
    name: string;
    email: string;
    accessToken: string;
    expiresIn: number;
  };
}

interface SigninVariables {
  email: string;
  password: string;
}

export const LoginPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();

  const [signin, { loading, error, data }] = useLazyQuery<
    SigninBackofficeData,
    SigninVariables
  >(SIGNIN, { client: authClient });

  useEffect(() => {
    if (data?.signinBackoffice) {
      const { id, name, email: userEmail, accessToken } = data.signinBackoffice;
      login(email, password, { id, name, email: userEmail }, accessToken);
    }
  }, [data, email, password, login]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    signin({ variables: { email, password } });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-100 via-warm-100 to-cream-200 dark:bg-gradient-to-br dark:from-dark-100 dark:via-dark-200 dark:to-dark-100 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white/80 dark:bg-dark-300/80 backdrop-blur-sm rounded-3xl shadow-soft-lg border-0 p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-soft-black dark:text-gray-100 mb-2">
              Campanhas
            </h1>
            <p className="text-soft-gray dark:text-gray-400">
              Faça login com sua conta do backoffice
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <Input
              type="email"
              label="Email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <Input
              type="password"
              label="Senha"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            {error && (
              <div className="bg-red-50 dark:bg-red-900/20 border-0 rounded-2xl p-4 shadow-soft">
                <p className="text-red-600 dark:text-red-400 text-sm font-medium">
                  {error.message === "Unauthorized"
                    ? "Email ou senha inválidos"
                    : "Erro ao fazer login. Tente novamente."}
                </p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full px-4 py-3 bg-soft-black hover:bg-soft-gray disabled:bg-soft-lightgray text-white font-medium rounded-2xl transition-all duration-300 disabled:cursor-not-allowed shadow-soft hover:shadow-soft-lg"
            >
              {loading ? "Entrando..." : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
